import { nsApi } from 'boot/axios'
// import colors from 'quasar/src/utils/colors.js';

export default {
  namespaced: true,

  state: {
    theme: null,
  },

  getters: {
    color: state => state.theme === 'Audiosoft' ? 'teal' : 'primary',
  },

  actions: {
    async init({ commit, state, rootState }, force = false) {
      if (!state.theme || force) {
        const { piva } = rootState.tenant
        const { data } = await nsApi.post('theme', { piva })
        commit('update', data)

        // configurazione colori
        // if (data === 'Audiosoft') {
        //   colors.setBrand('primary', '#007177')
        // } else {
        //   colors.setBrand('primary', '#007EC2')
        // }
      }
    },
  },

  mutations: {
    update(state, theme) { state.theme = theme },
  },
}
